import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/performance'
import config from '@/app.config'

!firebase.apps.length && firebase.initializeApp(config.FIREBASE)
export const GoogleProvider = new firebase.auth.GoogleAuthProvider()
export const auth = firebase.auth()
export const Persistence = firebase.auth.Auth.Persistence
export const perf = firebase.performance()
export const db = firebase.firestore()
export const Errors = {
  'auth/invalid-email': "L'indirizzo email non è corretto",
  'auth/user-not-found': 'Utente sconosciuto',
  'auth/wrong-password': 'Credenziali non valide'
}
export default firebase
